import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Stack,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import SportsMartialArtsIcon from "@mui/icons-material/SportsMartialArts";
// import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import AddKataDialog from "./AddKataDialog";
import AddTeamDialog from "./AddTeamDialog";
import ScanLicenseDialog from "./ScanLicenseDialog";
import AddJudokaDialog from "./AddJudokaDialog";

export default function ManageRegistration() {
  const individualCount = 0;
  const teamCount = 0;
  const kataCount = 0;
  const [addJudokaOpen, setAddJudokaOpen] = useState(false);
  const [scanOpen, setScanOpen] = useState(false);
  const [teamOpen, setTeamOpen] = useState(false);
  const [kataOpen, setKataOpen] = useState(false);

  return (
    <Box
      sx={{
        maxWidth: 1000,
        mx: "auto",
        px: 3,
        py: 4,
      }}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
      >
        Mes inscriptions
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4 }}
      >
        Open International de Sambreville
      </Typography>

      {/* Individuels */}

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <PersonIcon />
            <Typography variant="h6">
              Tournois individuels ({individualCount})
            </Typography>
          </Stack>
        </AccordionSummary>

        <AccordionDetails>
          {individualCount === 0 ? (
            <>
              <Typography sx={{ mb: 3 }}>
                Aucun judoka inscrit pour le moment.
              </Typography>

              <Stack spacing={2}>
                <Button
                  variant="outlined"
                  onClick={() => setScanOpen(true)}
                >
                  Scanner une licence
                </Button>

                <Button
                  variant="contained"
                  color="error"
                  onClick={() => setAddJudokaOpen(true)}
                >
                  Ajouter un judoka
                </Button>
              </Stack>
            </>
          ) : (
            <>
              {/* Liste des judokas */}
            </>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Inter-équipes */}

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <GroupsIcon />
            <Typography variant="h6">
              Inter-équipes ({teamCount})
            </Typography>
          </Stack>
        </AccordionSummary>

        <AccordionDetails>
          {teamCount === 0 ? (
            <>
              <Typography sx={{ mb: 3 }}>
                Aucune équipe inscrite pour le moment.
              </Typography>

              <Button
                variant="contained"
                color="error"
                onClick={() => setTeamOpen(true)}
              >
                Ajouter une équipe
              </Button>
            </>
          ) : (
            <>
              {/* Liste des équipes */}
            </>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Katas */}

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <SportsMartialArtsIcon />
            <Typography variant="h6">
              Katas ({kataCount})
            </Typography>
          </Stack>
        </AccordionSummary>

        <AccordionDetails>
          {kataCount === 0 ? (
            <>
              <Typography sx={{ mb: 3 }}>
                Aucun kata inscrit pour le moment.
              </Typography>

              <Button
                variant="contained"
                color="error"
                onClick={() => setKataOpen(true)}
              >
                Ajouter une équipe
              </Button>
            </>
          ) : (
            <>
              {/* Liste des katas */}
            </>
          )}
        </AccordionDetails>
      </Accordion>

      <AddJudokaDialog
        open={addJudokaOpen}
        onClose={() => setAddJudokaOpen(false)}
      />

      <ScanLicenseDialog
        open={scanOpen}
        onClose={() => setScanOpen(false)}
      />

      <AddTeamDialog
        open={teamOpen}
        onClose={() => setTeamOpen(false)}
      />

      <AddKataDialog
        open={kataOpen}
        onClose={() => setKataOpen(false)}
      />
    </Box>
  );
}